import angular from "assets/img/tech_stack/icon-angular.png";
import JavaScript from "assets/img/tech_stack/JavaScript-logo.png";
import react from "assets/img/tech_stack/icon-react.png";
import Tailwind_CSS_Logopng from "assets/img/tech_stack/Tailwind_CSS_Logopng.png";
import mui from "assets/img/tech_stack/mui.png";
import bootstrap from "assets/img/tech_stack/icon-bootstrap.png";

const textProps = {
  heading3: {
    title: "Front-End",
    alignment: "center",
  },

  infoAreas: [
    {
      image: angular,
      name: "Angular",
    },
    {
      image: JavaScript,
      name: "JavaScript",
    },
    {
      image: react,
      name: "React",
    },
    {
      image: Tailwind_CSS_Logopng,
      name: "Tailwind",
    },
    {
      image: mui,
      name: "Material UI",
    },
    {
      image:  bootstrap,
      name: "Bootstrap",
    },
  ],
};
export default textProps;
